<div class="flex-direction-column align-center gap-15 container-balao-sugestao">
  <span class="font-24 weight-700">Que tal personalizar seu Perfil?</span>
  <span class="font-12 weight-400">Para completar o seu perfil e melhorar a experiência no sistema, por favor,
    faça o upload de uma foto. Isso vai ajudar a identificá-lo(a)
    de forma mais eficiente.</span>
  <div>
    <app-button-padrao
      [width]="'325px'"
      [borderRadius]="'7px'"
      [label]="'Enviar minha foto'"
      [fontSize]="'14px'"
      (buttonClick)="fileInputUsu.click()"
    >
    </app-button-padrao>
    <input type="file" accept="image/*" #fileInputUsu (change)="selecionarFotoUsuario($event);" hidden="" />
  </div>
</div>
